import { adaptValue } from '../../../utils/adaptValue'
import { removeSpaces } from '../../../utils/removeSpaces'
import apinode from '../../apinode'

class PessoasService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  async getAll(withBalance = false) {
    const queryParams = withBalance ? '?type=with_balance' : ''

    const response = await apinode.get(`/pessoas/${this.idconta}${queryParams}`)

    return response.data
  }

  async getAllSuppliers() {
    const response = await apinode.get(`/pessoas/suppliers/${this.idconta}`)

    return response.data
  }

  async getBySearch({ search }) {
    const response = await apinode.get(
      `/pessoas/search/${this.idconta}?search=${search}`,
    )

    return response.data
  }

  async getBalanceByCodPessoa({ codPessoa }) {
    const response = await apinode.get(
      `/pessoas/${codPessoa}/balance/${this.idconta}`,
    )

    return response.data
  }

  async getById(customerId) {
    const { data } = await apinode.get(`/pessoas/${this.idconta}/${customerId}`)

    const dataFormatted = removeSpaces(data)

    return dataFormatted
  }

  async create(data) {
    const dataFormatted = removeSpaces(data)

    await apinode.post(`/pessoas/${this.idconta}`, {
      ...dataFormatted,
    })
  }

  async update(codPessoa, data) {
    const dataFormatted = removeSpaces(data)

    await apinode.put(`/pessoas/${this.idconta}/${codPessoa}`, {
      ...dataFormatted,
    })
  }

  async updateBalance({ codPessoa, type, value, id_pedido }) {
    await apinode.patch(`/pessoas/${this.idconta}`, {
      codPessoa,
      type,
      value: adaptValue(value),
      id_funcionario: localStorage.idusuario,
      id_pedido,
    })
  }

  async exportToMatriz(codPessoa) {
    await apinode.get(`/pessoas/${this.idconta}/${codPessoa}/export`)
  }

  async delete(codPessoa) {
    await apinode.delete(`/pessoas/${this.idconta}/${codPessoa}`)
  }
}

export default new PessoasService()
